import React, { useEffect, useState } from "react";
import Axios from "axios";
import { useParams } from "react-router-dom";
import withLanguage from "../../HOC/withLanguage";


const SubjectDetail = ({ language }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [subject, setSubject] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    const getSubjectData = async () => {
      try {
        const res = await Axios.get(`/api/data/get_employer_declaration/${id}`);
        console.log("API Response:", res.data); // Debug log

        // Fix: Access the first element of the array
        if (Array.isArray(res.data) && res.data.length > 0) {
          setSubject(res.data[0]);
        } else {
          setSubject(res.data);
        }
      } catch (err) {
        console.log("API Error:", err);
      } finally {
        setIsLoading(false);
      }
    };
    getSubjectData();
  }, [id]);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "Not provided";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return dateString;
    }
  };

  const getMimeType = (base64) => {
    if (!base64) return "image/jpeg";

    if (base64.startsWith("/9j/")) return "image/jpeg";
    if (base64.startsWith("aVZCT")) return "image/png";
    if (base64.startsWith("R0lGOD")) return "image/gif";
    if (base64.startsWith("PHN2Zy")) return "image/svg+xml";
    if (base64.startsWith("UklGR")) return "image/webp";

    return "image/jpeg";
  };

  const normalizeBase64 = (b64) => {
    try {
      const decoded = atob(b64);

      if (decoded.startsWith("iVBOR") || decoded.startsWith("/9j/")) {
        return decoded;
      }

      return b64;
    } catch {
      return b64;
    }
  };

  const normalized = normalizeBase64(subject?.image);
  const mimeType = getMimeType(normalized);

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center">Loading...</div>
      ) : (
        subject && (
          <section className="relative max-w-6xl mt-20 mx-auto bg-white border border-gray-100 rounded-xl p-8 shadow-custom">

            <img
                src={`data:${mimeType};base64,${normalized}`}
                alt={subject?.employer_name}
                className="w-24 md:w-44 h-auto absolute right-8 top-8 mb-5"
                loading="lazy"
            />
           
            <h1 className="text-2xl md:text-4xl font-extrabold text-red-600 pb-10 pr-28 md:pr-48">
              {subject.employer_name}
            </h1>

            <div className="mt-0 md:mt-10">
              <p className="text-base mb-4">{subject.description}</p>
            </div>

            <div className="p-3 border border-[#DB3222] text-black">
              <div className="space-y-2">
                <DetailItem label={language.nipt} value={subject.nipt} />
                <DetailItem
                  label={language.fieldOfActivity}
                  value={subject.field_of_activity}
                />
                <DetailItem label={language.address} value={subject.address} />
                <DetailItem label={language.contactNumber} value={subject.contact_nr} />
                <DetailItem
                  label={language.website}
                  value={subject.website}
                  isLink={true}
                />
                <DetailItem
                  label={language.yearOfEnrollment}
                  value={formatDate(subject.year_of_enrollment)}
                />
              </div>
            </div>
          </section>
        )
      )}
    </>
  );
};

export default withLanguage(SubjectDetail, "SubjectDetail");

// Updated Detail Item Component
const DetailItem = ({ label, value, isLink = false }) => (
  <div className="flex flex-col sm:flex-row sm:items-start ">
    <span className="text-black font-bold sm:w-2/5 sm:mb-0 min-w-[140px]">
      {label}:
    </span>
    <span className="sm:w-3/5 text-black break-words">
      {isLink && value ? (
        <a
          href={value.startsWith("http") ? value : `https://${value}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-black break-all"
        >
          {value}
        </a>
      ) : value ? (
        value
      ) : (
        <span className="text-black italic">Not provided</span>
      )}
    </span>
  </div>
);
